import React from 'react';
import './index.css';
import BrandAnalysisTable from "../ThirdPage/BrandAnalysisTable";
import PlatformAnalysisTable from "../ThirdPage/PlatformAnalysisTable";
import BarChart from "./BarChart";

import {
    Flex,
    Heading,
    Text,
    SimpleGrid,
    useColorModeValue,
} from "@chakra-ui/react";

const ThirdPage = (props) => {
    const { brandWise, platformWise
    } = props;


    const textColor = useColorModeValue("secondaryGray.900", "white");

    return (
        <div className="third-page">
            <Heading fontSize='24px' mb='10px'>
                <Flex paddingBottom='10px' justify='space-between' align='center'>
                    <Text
                        color={textColor}
                        lineHeight='100%'
                        m='auto'
                        className="heading1"
                    >
                        DETAIL ANALYSIS
                    </Text>
                </Flex>
            </Heading>
            <div className="brand-analysis-section">
                <Flex px='10px' paddingBottom='20px' justify='space-between' align='center'>
                    <Text
                        color={textColor}
                        lineHeight='100%'
                        m='auto'
                        className="heading2"
                    >
                        Brand-wise
                    </Text>
                </Flex>
                <div className="analysis-content">
                    <SimpleGrid columns="2" gap='10px' mb='50px'>
                        <BrandAnalysisTable finalData={brandWise} heading="Brands" />
                        <BarChart finalData={brandWise} />
                    </SimpleGrid>
                </div>
            </div>

            <div className="platform-analysis-section">
                <Flex px='10px' paddingBottom='20px' justify='space-between' align='center'>
                    <Text
                        color={textColor}
                        lineHeight='100%'
                        m='auto'
                        className="heading2"
                    >
                        Platform Analysis
                    </Text>
                </Flex>
                <div className="analysis-content">
                    <SimpleGrid columns="2" gap='10px' mb='50px'>
                        <BrandAnalysisTable finalData={platformWise} heading="Platforms" />
                        <BarChart finalData={platformWise} />
                    </SimpleGrid>
                </div>
            </div>
            {/* </Flex> */}
        </div>
    );
};

export default ThirdPage;
